import React, { useEffect } from "react";
import { Container, Row, Col, Button, Image } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { getPracticeById } from "../api";

export function PaymentPage() {
  const navigate = useNavigate();
  const { practiceId, status } = useParams();
  const [practice, setPractice] = React.useState({}); // Initialize practice state
  const [logo, setLogo] = React.useState(""); // Initialize logo state

  useEffect(() => {
    const fetchPractice = async () => {
      try {
        const response = await getPracticeById(practiceId);
        setPractice(response);
        setLogo(response.logoURL); // Set logo URL from the response
      } catch (error) {
        console.error("Error fetching practice:", error);
      }
    };

    fetchPractice();
  }, [practiceId, status]); // Fetch practice when practiceId or status changes

  const messages = {
    success: {
      title: "Payment Successful",
      description: "Thank you! Your payment has been processed successfully.",
      icon: <i className="fa-solid fa-check-circle fa-5x text-success mb-3" />,
      buttonText: "Return to Dashboard",
      onClick: () => navigate("/"),
    },
    error: {
      title: "Payment Error",
      description:
        "Oops! Something went wrong with your payment. Please try again or contact support.",
      icon: <i className="fa-solid fa-times-circle fa-5x text-danger mb-3" />,
      buttonText: "Try Again",
      onClick: () => navigate("/payment"),
    },
    cancel: {
      title: "Payment Cancelled",
      description:
        "You have cancelled the payment process. No charges have been made.",
      icon: <i className="fa-solid fa-ban fa-5x text-warning mb-3" />,
      buttonText: "Start Over",
      onClick: () => navigate("/payment"),
    },
  };

  // Fallback to error if status is unrecognized
  const { title, description, icon } = messages[status] || messages.error;
  console.log("logo", logo);
  return (
    <Container className="d-flex flex-column justify-content-center align-items-center shadow-lg vh-100">
      <Row className="mb-4">
        {logo && (
          <Image
            src={logo}
            alt={`${practice.name} logo`}
            fluid
            className="d-block mx-auto"
            style={{ maxWidth: "400px" }}
          />
        )}
      </Row>

      <Row className="shadow-sm p-5 rounded text-center">
        <Col>
          <div className="d-flex align-items-center justify-content-center mb-3">
            {icon}
            <h2 className="ms-4 mb-0">{title}</h2>
          </div>
          <p className="mt-2">{description}</p>
        </Col>
      </Row>

      <Row className="mt-4 w-100 px-5">
        <Col md={3}></Col>

        <Col md={3} className="text-start">
          <h6 className="border-bottom mb-1">{practice.practiceName}</h6>
          <strong>Practice #:</strong> {practice.practiceNumber}
          <br />
          {practice.VATNumber && (
            <>
              <strong>VAT #:</strong> {practice.VATNumber}
              <br />
            </>
          )}
          <i className="fa-solid fa-phone me-2"></i>
          {practice.practicePhoneNumber}
          <br />
          <i className="fa-regular fa-envelope me-2"></i>
          {practice.practiceEmail}
          <br />
          {practice.practiceWebsite && (
            <>
              <i className="fa-solid fa-globe me-2"></i>
              {practice.practiceWebsite}
              <br />
            </>
          )}
        </Col>

        <Col md={3} className="text-end">
          <h6 className="invisible">Address</h6>{" "}
          {/* Placeholder to align with the heading on the left */}
          {practice.practiceAddress}, {practice.practiceAddress2}
          <br />
          {practice.practiceCity}, {practice.practicePostalCode}
        </Col>

        <Col md={3}></Col>
      </Row>
        {/* Footer: Powered by PractoSync */}
  <Row className="w-100 justify-content-end px-2 mt-5 border-top">
    <Col md="auto" className="text-end">
      <small className="text-muted">Powered by:</small>
      <Image
        src="https://practostorage.blob.core.windows.net/practopublic/logo.png"
        alt="PractoSync"
        style={{ maxHeight: "50px", marginLeft: "10px" }}
        fluid
      />
    </Col>
  </Row>
    </Container>
  );
}
